module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAAAXNSR0IArs4c6QAAAGNJREFUKFNj5Nrc9p8BD/jH8L/hh291I0wJI0jDN98qRlx6QPLImojSwMDAePUfw7/VIJuI1ACxH2QTQQ3ITgU5D0UDegCg+w1DA77QAslRrgFXnMCcRrkNJPthEDmJkNuR5QESlHOl1VScjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fileG.png
// module id = 419
// module chunks = 0